import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';

export const GET_MY_REWARDS_REQUEST = 'GET_MY_REWARDS_REQUEST';
export const GET_MY_REWARDS_SUCCESS = 'GET_MY_REWARDS_SUCCESS';
export const GET_MY_REWARDS_ERROR = 'GET_MY_REWARDS_ERROR';

export function fetchMyRewards() {
	return dispatch => {
		dispatch(requestMyRewards());

		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/1/user/rewards'
			})
		).then(
			json => dispatch(receiveMyRewardsSuccess(json['RESPONSE'])),
			err => {
				dispatch(receiveMyRewardsError(err));
				return Promise.reject(err);
			}
		);
	};
}

const requestMyRewards = () => {
	return {
		type: GET_MY_REWARDS_REQUEST
	};
};

const receiveMyRewardsSuccess = response => {
	return {
		type: GET_MY_REWARDS_SUCCESS,
		data: response
	};
};

const receiveMyRewardsError = errorParam => {
	return {
		type: GET_MY_REWARDS_ERROR,
		error: errorParam
	};
};
